import api from '@/utils/api';

/**
 * Get a Company's single price
 * @param {string} companyId - Query to filter companies
 * @param {string} priceId - The price id
 * @returns {Promise}
 */
const getCompanyPriceApi = (companyId, priceId) =>
  api.get(`company/${companyId}/price/${priceId}`);

export default getCompanyPriceApi;
